// Detail/form page chrome shared by Settings entity pages (MVP-31132). Mirrors the styled blocks
// in screen/PhysicianManagement/PhysicianDetail.js.
import { Typography } from "antd";
import styled from "styled-components";

import { WHITE, BLACK } from "../../../constant/colors";

const { Text } = Typography;

export const DetailPageContainer = styled.div`
  width: 98%;
  margin: 0 auto;
  padding: 20px;
  background: ${WHITE};
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  height: calc(100vh - 100px);
  overflow-y: auto;
`;

export const DetailHeaderSection = styled.div`
  flex-shrink: 0;
  padding: 8px 4px;
  margin-bottom: 16px;
`;

// Facility pages: same 16px card padding as the Facilities list so the breadcrumbs sit at the
// exact same spot on the list, detail and edit pages (no jump when navigating between them).
export const CompactDetailPageContainer = styled(DetailPageContainer)`
  padding: 16px;
`;

// Header without the extra spacing (used by the Facility pages; Figma gap to the first section is a
// single 16px, and the breadcrumbs start flush with the card padding like on the list page).
// Nested MetaText keeps its font but drops its own margin.
export const CompactDetailHeaderSection = styled(DetailHeaderSection)`
  margin-bottom: 16px; /* Figma PageContent/Facilities column gap */
  padding: 0;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
`;

export const FieldLabel = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  color: ${BLACK};
`;

export const FieldValue = styled(Text)`
  font-size: 16px;
  color: ${BLACK};
`;

export const PageHeading = styled.h1`
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 700;
  color: ${BLACK};
  margin: 0 0 4px 0;
`;
